import axios from "axios";
import { Settings } from "../../settings";
const UPDATE_INPUT_VALUE = "UPDATE_INPUT_VALUE";
const CLEAR_SUGGESTIONS = "CLEAR_SUGGESTIONS";
const MAYBE_UPDATE_SUGGESTIONS = "MAYBE_UPDATE_SUGGESTIONS";
const LOAD_SUGGESTIONS_BEGIN = "LOAD_SUGGESTIONS_BEGIN";
const languages = [
  {
    name: "C",
    year: 1972
  },
  {
    name: "C#",
    year: 2000
  },
  {
    name: "C++",
    year: 1983
  },
  {
    name: "Clojure",
    year: 2007
  },
  {
    name: "Elm",
    year: 2012
  },
  {
    name: "Go",
    year: 2009
  },
  {
    name: "Haskell",
    year: 1990
  },
  {
    name: "Java",
    year: 1995
  },
  {
    name: "Javascript",
    year: 1995
  },
  {
    name: "Perl",
    year: 1987
  },
  {
    name: "PHP",
    year: 1995
  },
  {
    name: "Python",
    year: 1991
  },
  {
    name: "Ruby",
    year: 1995
  },
  {
    name: "Scala",
    year: 2003
  }
];

function getSuggestions(value) {
  const escapedValue = escapeRegexCharacters(value.trim());

  if (escapedValue === "") {
    return [];
  }

  const regex = new RegExp("^" + escapedValue, "i");

  return languages.filter(language => regex.test(language.name));
}

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function getMatchingLanguages(value) {
  const escapedValue = escapeRegexCharacters(value.trim());

  if (escapedValue === "") {
    return [];
  }

  const regex = new RegExp("^" + escapedValue, "i");

  return languages.filter(language => regex.test(language.name));
}
export const loadSuggestions = value => {
  return dispatch => {
    dispatch(loadSuggestionsBegin());

    var url =
      /* "https://cors-anywhere.herokuapp.com/" +*/
      Settings().MODEL_SEARCH_URL + value;
    axios.get(url).then(function(response) {
      if (response.data.status === "success") {
        let models = [];
        for (var i = 0; i < response.data.model_numbers.length; i++) {
          const modelNumber = response.data.model_numbers[i].replace(/~/g, "/");
          // Filter out "NA" values
          if (modelNumber !== "NA") {
            models.push(modelNumber);
          }
        }
  
        //alert("chnaged models");
        dispatch(maybeUpdateSuggestions(models, value));
      } else {
        dispatch(maybeUpdateSuggestions([], value));
      }
    });
  };
};
export const loadNewSuggestions = value => {
  return dispatch => {
    dispatch(loadSuggestionsBegin());

    var url = Settings().NEW_MODEL_SEARCH_URL + value;
    axios.get(url).then(function(response) {

      if (response.data.status === "success") {
        let models = [];
        for (var i = 0; i < response.data.model_numbers.length; i++) {
          const modelNumber = response.data.model_numbers[i].replace(/~/g, "/");
          // Filter out "NA" values
          if (modelNumber !== "NA") {
            models.push(modelNumber);
          }
        }
   
        dispatch(maybeUpdateSuggestions(models, value));
      } else {
        dispatch(maybeUpdateSuggestions([], value));
      }
    });
  };
};

export const updateInputValue = value => {
  return {
    type: UPDATE_INPUT_VALUE,
    value
  };
};

export const clearSuggestions = () => {
  return {
    type: CLEAR_SUGGESTIONS
  };
};

const loadSuggestionsBegin = () => {
  return {
    type: LOAD_SUGGESTIONS_BEGIN
  };
};

const maybeUpdateSuggestions = (suggestions, value) => {
  return {
    type: MAYBE_UPDATE_SUGGESTIONS,
    suggestions,
    value
  };
};
